import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NotificationService } from "@app/services/notification.service";
import { CurrencyService } from "@app/services/currency.service";
import { BranchService } from "@app/services/branch.service";
import { Branch } from '@app/models/branch';
import { Currency } from '@app/models/currency';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { AccountFilter } from '@app/models/account-filter';

@Component({
    selector: 'app-account-filter',
    templateUrl: './account-filter.component.html',
    styleUrls: ['./account-filter.component.css'],
    standalone: false
})
export class AccountFilterComponent implements OnInit, OnChanges {

  @Input() accountFilter: AccountFilter;
  @Input() isFilterAccount: boolean;
  @Input() isForeignCurrencyAccount: boolean;
  @Input() currency: string;
  @Output() submit = new EventEmitter<AccountFilter>();
  @Output() cancel = new EventEmitter();

  branchCodeList: Branch[];
  currencyList: Currency[];
  displaySearchDialog: boolean = false;
  timerForAutoSearch: any;
  orignalAccountFilter: AccountFilter;

  constructor(
    private notificationService: NotificationService,
    private currencyService: CurrencyService,
    private branchService: BranchService) { }

  ngOnInit(): void {
    this.getBranches();
    this.getCurrencies();
  }

  ngOnChanges() {
    this.orignalAccountFilter = { ...this.accountFilter };
  }

  getBranches() {
    const pageOption = {
      size: 10000,
      page: 0
    }
    const pageParams = { ...pageOption };
    this.branchService.getList(pageParams).subscribe({
      next: (data) => {
        this.branchCodeList = data.content;
        this.branchCodeList.unshift({
          address: "",
          id: "",
          subBranches: [],
          name: 'All',
          code: 'ALL',
          country: '',
          state: '',
          city: '',
          subCity: '',
          branchNodeId: '',
          details:'',
          phoneNumber1: '',
          phoneNumber2: '',
          latitude: '',
          longitude: '',
          plusCode: '',
          parentBranchNodeName: '',
          parentBranchNodeId:'',
          workingTime: []
        })
      },
      error: (err) => this.notificationService.showErrorMessage(`${MethodsHelper.showErrorMessageStyling(err)}`)
    });
  }

  getCurrencies() {
    const pageOption = {
      size: 1000,
      page: 0
    }

    const pageParams = { ...pageOption };
    this.currencyService.getList(pageParams).subscribe({
      next: (data) => {
        this.currencyList = data.content.filter(p => p.enabled).sort((a, b) => a.name.localeCompare(b.name));

        if (this.isForeignCurrencyAccount) {
          this.currencyList = this.currencyList.filter(p => !p.default);
        }

        if (this.currency) {
          const matchedCurrency = this.currencyList.find(c => c.isoCode === this.currency);
          if (matchedCurrency) {
            this.currencyList = [matchedCurrency];
            this.accountFilter.currency = this.currency;
          }
        } else {
          this.currencyList.unshift({
            name: 'All',
            id: 'ALL',
            accountSuffix: "",
            default: false,
            enabled: true,
            isDefault: false,
            isoCode: "All",
            symbol: ""
          });
        }
      },
      error: (err) => this.notificationService.showErrorMessage(`${MethodsHelper.showErrorMessageStyling(err)}`)
    });
  }

  haveChangeInFilter() {
    for (let key in this.accountFilter) {
      if (MethodsHelper.convertToEmpty(this.orignalAccountFilter[key]) != MethodsHelper.convertToEmpty(this.accountFilter[key])) {
        return true;
      }
    }
    for (let key in this.orignalAccountFilter) {
      if (MethodsHelper.convertToEmpty(this.orignalAccountFilter[key]) != MethodsHelper.convertToEmpty(this.accountFilter[key])) {
        return true;
      }
    }
    return false;
  }

  triggerFilterAccount() {
    if (this.haveChangeInFilter()) {
      this.orignalAccountFilter = { ...this.accountFilter };
      
      let submitFilter = {...this.accountFilter};
      if (submitFilter.branchCode == 'ALL') {
        submitFilter.branchCode = undefined;
      }
      if (submitFilter.currency == 'ALL' || submitFilter.currency == 'All') {
        submitFilter.currency = undefined;
      }
      this.submit.emit(submitFilter);
    }
  }

  timeoutToTrigger() {
    clearTimeout(this.timerForAutoSearch);
    this.timerForAutoSearch = setTimeout(() => {
      this.triggerFilterAccount();
    }, 1500);
  }

  resetFilterAccount() {
    this.cancel.emit();
  }

  showAdvancedSearch() {
    this.displaySearchDialog = true;
  }

  hideAdvancedSearch() {
    this.displaySearchDialog = false;
  }

  onSubmitSelectedCustomer(customer) {
    if (customer) {
      this.accountFilter.customerAccountNumber = customer.customerNumber;
      this.triggerFilterAccount();
    }
    this.hideAdvancedSearch();
  }

}
